import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './Header.scss';
// import Logo from '../img/spectrio-logo.svg';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      on: true,
      isTop: true
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({on: !prevState.on}));
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 1;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    });
  }
  render () {
    return (
        <div className={'white-header ' + this.props.location.pathname.replace(/\//g, '')}>

          <header id="header" className={`header ${this.state.isTop ? '' : 'header--scrolled'}`}>
            <div className="container">
              <div className="header__logo">
                <a href="https://www.spectrio.com/">
                  <div className="header__logo--main">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 657.78 173.5"><path d="M45.71 75.26c-13.15-2.42-21.18-4.28-21.18-11.22 0-9.32 13.03-10.33 18.6-10.33 8.28-.15 16.42 2.23 23.32 6.82l4.03 2.7 9.2-16.9-3.11-2.1a63.249 63.249 0 00-33.36-8.92c-23.56 0-38.77 11.46-38.77 29.13 0 22.63 20.17 26.18 36.31 29.09 12.75 2.26 20.53 4.03 20.53 10.41 0 2.5 0 10.17-19.28 10.17a49.071 49.071 0 01-28.89-9.2l-3.71-2.78L0 118.55l2.58 2.3c8.07 7.06 23.64 11.82 38.37 11.82 24.85 0 40.34-11.18 40.34-29.13-.12-21.82-19.81-25.41-35.58-28.28zm96.58-40.02a43.73 43.73 0 00-29.65 10.69V35.89H92.99V173.5h20.17v-51.2a43.475 43.475 0 0029.13 10.37c27.72 0 47.81-20.53 47.81-48.82s-20.09-48.61-47.81-48.61zm-.81 18.64c16.46 0 28.24 12.63 28.24 29.98s-11.7 29.98-28.24 29.98-28.52-12.1-28.52-29.98 11.74-29.98 28.52-29.98zm100.9-18.64c-27.19 0-46.96 20.45-46.96 48.41s20.62 48.82 50.15 48.82c14.02.62 27.58-5.05 37-15.45l2.26-2.74-12.1-13.96-3.11 3.63A30.434 30.434 0 01245.94 114c-15.49 0-26.79-8.55-29.69-22.11h72.62V84.19c.15-28.94-19.01-48.95-46.49-48.95zm0 18.48c12.7-.48 23.85 8.35 26.3 20.82h-52.45c2.38-12.46 13.49-21.3 26.15-20.82zm101.27.16c8.76-.29 17.06 3.91 22.03 11.13l2.3 3.51 15.61-10.57-2.06-3.39c-7.58-12.47-21.02-19.32-37.88-19.32-28.56 0-49.3 20.45-49.3 48.41s20.74 48.82 49.3 48.82c16.74 0 30.18-6.86 37.84-19.28l2.1-3.43-15.61-10.57-2.3 3.47a25.565 25.565 0 01-22.03 10.97c-17.07 0-29.01-12.1-29.01-29.98s11.94-29.77 29.01-29.77zm95.97 56.88a15.311 15.311 0 01-10.21 3.39c-7.5 0-10.97-3.75-10.97-11.78V54.2h26.67V35.89h-26.63V16.76h-20.17v19.12h-15.65l15.65 18.32v48.82c0 18.56 11.13 29.65 29.77 29.65 7.72.22 15.27-2.35 21.26-7.22l2.38-2.1-8.07-16.14-4.03 3.55zm42.28-66.04v-8.84h-19.65v95.94h20.17V83.05c0-18.15 9-28.24 25.34-28.24h.85c.66.04 1.32.04 1.98 0h4.03V35.24h-4.03a41.88 41.88 0 00-28.69 9.48zM536.21.02c-6.94-.39-12.89 4.91-13.28 11.85-.39 6.94 4.91 12.89 11.85 13.28.47.03.95.03 1.42 0 6.94.39 12.89-4.91 13.28-11.85.39-6.94-4.91-12.89-11.85-13.28-.47-.03-.95-.03-1.42 0zm-10.17 35.87h20.13v95.94h-20.13zm83.07-.65c-26.92-.04-48.77 21.74-48.81 48.66-.04 26.92 21.74 48.77 48.66 48.81 26.92.04 48.77-21.74 48.81-48.66v-.4c.75-25.99-19.71-47.67-45.7-48.42-1-.03-1.98-.02-2.96.01zm0 78.59c-16.74 0-28.44-12.1-28.44-29.98s11.7-29.98 28.44-29.98 28.24 12.35 28.24 29.98-11.54 29.98-28.24 29.98z" /></svg>
                  </div>
                </a>
              </div>
              <nav className="header__nav">
                {/*<ul>
                  <li className="has-dropdown product-ddl" data-content="products">
                    <button>Solutions</button>
                  </li>
                  <li className="has-dropdown enterprise-ddl" data-content="enterprise">
                    <a href="/enterprise/">Enterprise</a>
                  </li>
                  <li className="has-dropdown industry-ddl" data-content="industries">
                    <button>Industries</button>
                  </li>
                  <li className="has-dropdown pricing-ddl" data-content="pricing">
                    <a href="/pricing/">Pricing</a>
                  </li>
                  <li className="has-dropdown product-ddl" data-content="products">
                    <button>Resources</button>
                  </li>
                </ul>*/}
              </nav>
              <div className="header__cta-buttons">
                <div className="d-none d-lg-inline-block">
                  <a href="https://cloud.spectrio.com/login" className="btn btn-ghost">
                    <span className="btn__text">
                      Log In            </span>
                    <span className="btn__icon">
                      <i className="fa fa-chevron-right"></i>
                    </span>
                  </a>
                  <div className="retro-btn-container smaller">
                    <a href="https://www.spectrio.com/demo/" className="btn btn-primary btn-retro">
                      <span className="btn__text">
                        Sign Up
                      </span>
                      <span className="btn__icon">
                        <i className="fa fa-chevron-right"></i>
                      </span>
                    </a>
                  </div>
                </div>
                <div className="header__nav-trigger d-lg-none">
                  {/*<button id="mobile-nav-trigger" aria-label="mobile-navigation-trigger">
                    <i className="fal fa-bars"></i>
                    <i className="fal fa-times"></i>
                  </button>*/}
                </div>
              </div>
            </div>
          </header>

        </div>
    )
  }
}

export default withRouter(Header);